module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// d:/documents/git/krkrsvchk/krkrsvchk_web/~/material-ui/~/babel-runtime/~/core-js/library/modules/_fails.js
// module id = 201
// module chunks = 1